import { Button, TButtonType } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';

export interface LoginButtonProps {
  isLoading: boolean;
  disabled?: boolean;
  type?: TButtonType;
  text?: string;
  onClick?: () => void;
  icon?: string;
}

const LoginButton = (props: LoginButtonProps): React.JSX.Element => {
  const { isLoading, disabled, type, text, onClick, icon } = props;
  const {
    translateStore: { translate },
  } = useStores();

  return (
    <Button
      text={text || translate('button.login')}
      iconRight={icon || '#arrow-right'}
      block={true}
      isLoading={isLoading}
      disabled={disabled}
      type={type}
      attributes={{ type: 'submit' }}
      onClick={() => onClick && onClick()}
    />
  );
};

export default observer(LoginButton);
